function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveryIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19869"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19858"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "sticky-note (1)",
    transform: "translate(1.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 20681",
    width: 37.616,
    height: 37.616,
    rx: 2,
    transform: "rotate(4.992 -81.649 41.173)",
    style: {
      fill: "#c9c9c9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 20682",
    width: 37.616,
    height: 37.616,
    rx: 2,
    transform: "rotate(-4.992 78.657 -39.138)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59588",
    d: "M45.025 13.7a.894.894 0 0 1-.333-.068.861.861 0 0 1-.453-1.12l2.561-5.99a.849.849 0 0 1 1.12-.445.861.861 0 0 1 .453 1.12l-2.565 5.984a.853.853 0 0 1-.787.521z",
    transform: "translate(-11.542 -4.291)",
    style: {
      fill: "#536882"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1125",
    cx: 2.565,
    cy: 2.565,
    r: 2.565,
    transform: "translate(33.483)",
    style: {
      fill: "#335068"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59616",
    d: "M4.038 10.091h2.007V6.045h4.045V4.038H6.045V0H4.038v4.038H0v2.007h4.038zm21.823-6.456h-6.777v1.933h6.777z",
    transform: "rotate(-6.02 199.959 -110.536)",
    style: {
      fill: "#0a243f"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryIcon1);
export default __webpack_public_path__ + "static/media/delivery-icon1.2b806e9bdce1b7aa64cf504ca50fc2ce.svg";
export { ForwardRef as ReactComponent };